import { render, staticRenderFns } from "./FormControlOdpCourseDatesPromotionId.vue?vue&type=template&id=3c7b1dba"
import script from "./FormControlOdpCourseDatesPromotionId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlOdpCourseDatesPromotionId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports